import './App.css';
import Header from './component/header';
import Footer from './component/footer';
import Mainpage from './component/mainpage';
import Notfound from './component/404';
import Write from './pages/new/write';
import Postbox from './component/post-box';
import Postviewer from './pages/post/post';
import Editpost from './pages/edit/edit';
import Opensourcelicence from './pages/licence/licence';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { useState } from 'react';
import Login from './pages/login/login';
import Signup from './pages/login/signup';


function App() {
  const [htmlContent, setHtmlContent] = useState('');

  return (
    <div>
      <BrowserRouter>
      <Header />
      <Routes>
        <Route path='/docs/opensourcelicense' element={<Opensourcelicence />}></Route>
        <Route path='/post/new' element={<Write htmlContent={htmlContent} setHtmlContent={setHtmlContent} />}></Route>
        <Route path='/post' element={<Postviewer />}></Route>
        <Route path='/post/edit' element={<Editpost htmlContent={htmlContent} setHtmlContent={setHtmlContent} />}></Route>
        <Route path='/login' element={<Login />}></Route>
        <Route path='/admin/signup' element={<Signup />}></Route>
        <Route path='/' element={<Mainpage />}></Route>
        <Route path='*' element={<Notfound />}></Route>
      </Routes>
      </BrowserRouter>
      <Footer />
    </div>
  );
}

export default App;